/**
 * The render mode of the task editor to display
 */ export var TaskEditorRenderMode = /*#__PURE__*/ function(TaskEditorRenderMode) {
    /** Modal dialog view */ TaskEditorRenderMode["Dialog"] = "dialog";
    /** Side panel (sidecar) view */ TaskEditorRenderMode["Panel"] = "panel";
    return TaskEditorRenderMode;
}({});
